<app-kiosk-mode-checker [logoutModal]="true" [description]="'KIOSK_ENTER_PIN'|translate"
  (kioskCheckerActive)="disableKioskMode()" (onExitKioskMode)="onExitKioskMode.emit(false)">
</app-kiosk-mode-checker>
